import type { BillingEventStatus, SubscriptionStatus } from '@/lib/api/types'

type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'outline'

const labels: Record<string, string> = {
  on_trial: 'On trial',
  active: 'Active',
  paused: 'Paused',
  past_due: 'Payment failing',
  unpaid: 'Unpaid',
  cancelled: 'Ending',
  expired: 'Ended',
  monthly: 'Monthly',
  annual: 'Annual',
  initial: 'First payment',
  renewal: 'Renewal',
  updated: 'Change',
  paid: 'Paid',
  pending: 'Pending',
  void: 'Void',
  refunded: 'Refunded',
  partial_refund: 'Partly refunded',
  processed: 'Applied',
  ignored: 'Ignored',
  failed: 'Failed',
}

/** Plain words for a status, interval or payment reason. */
export function label(value: string | null | undefined) {
  if (!value) return '—'
  return labels[value] ?? value.replace(/_/g, ' ')
}

export function subscriptionTone(status: SubscriptionStatus, cancelled = false): Tone {
  if (status === 'past_due' || status === 'unpaid') return 'danger'
  if (cancelled || status === 'cancelled' || status === 'paused') return 'warning'
  if (status === 'expired') return 'outline'
  return 'success'
}

export function invoiceStatusTone(status: string): Tone {
  if (status === 'paid') return 'success'
  if (status === 'refunded' || status === 'partial_refund') return 'warning'
  return 'neutral'
}

export function eventTone(status: BillingEventStatus): Tone {
  if (status === 'failed') return 'danger'
  if (status === 'pending') return 'warning'
  if (status === 'ignored') return 'outline'
  return 'success'
}
